"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveContactDetails = exports.getContactGroups = exports.default = void 0;
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
var getContactGroups = exports.getContactGroups = function getContactGroups(contractAccountId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/partner/v0/contact/").concat(contractAccountId));
};
var saveContactDetails = exports.saveContactDetails = function saveContactDetails(contractAccountId, dataObj) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/partner/v0/contact/").concat(contractAccountId), dataObj);
};
var _default = exports.default = getContactGroups;